/** Ab hier zeigt die Uhr nur noch Minuten. */
const MINUTES_ONLY_FROM = 5 * 60

/**
 * Die Zeit **im Chip des Fokus-Fensters** — hochgezählt, heruntergezählt oder
 * in der Überzeit.
 *
 * Die ersten fünf Minuten sekundengenau und stellenfest (`4:24`), danach nur
 * noch Minuten wie der Dauer-Marker — `6m`, `1h`, `6h 5m` (22.09.2026: die
 * tickenden Sekunden lenken nur ab). Angefangene Minuten zählen noch nicht, so
 * geht es beim Herunterzählen von `5m` nahtlos in `4:59` über.
 *
 * Läuft die Dauer ins Plus, steht ein `+` davor (`+0:07`, `+6m`): Der Countdown
 * zählt **still** weiter, niemand wird gemeldet, nur der Chip färbt sich um.
 *
 * Getrennt von `formatFocusDuration` (3e, „25 Min" / „1 Std 20 Min"): Die
 * Anzeige an Zeile, Details und **Geschafft** liest sich als Satz.
 */
export function formatFocusClock(seconds: number): string {
  const sign = seconds < 0 ? '+' : ''
  const total = Math.abs(Math.trunc(seconds))

  if (total < MINUTES_ONLY_FROM) {
    const minutes = Math.floor(total / 60)
    const secs = String(total % 60).padStart(2, '0')
    return `${sign}${minutes}:${secs}`
  }

  const totalMinutes = Math.floor(total / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours === 0) return `${sign}${minutes}m`
  if (minutes === 0) return `${sign}${hours}h`
  return `${sign}${hours}h ${minutes}m`
}
